var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "serviceplace-information mt-1" },
    [
      _c(
        "validation-observer",
        { ref: "formValidator" },
        [
          _c("div", { staticClass: "license-disciplines-title mx-4" }, [
            _vm._v(
              " Seleccione la(s) Disciplina(s) de Licencia(s) a las que desea añadir Lugar(es) de Servicio(s) "
            )
          ]),
          _vm._l(_vm.specialistLicenseDisciplines, function(
            licenseDisciplines
          ) {
            return _c(
              "div",
              {
                key: licenseDisciplines.specialistLicenseId,
                staticClass: "row mx-4"
              },
              [
                _c(
                  "div",
                  { staticClass: "col-12 mx-3 license-disciplines-container" },
                  [
                    _c("div", { staticClass: "license-label" }, [
                      _vm._v(
                        " " +
                          _vm._s(licenseDisciplines.licenseSpecialtyName) +
                          " "
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "mt-1 disciplines-container" },
                      _vm._l(licenseDisciplines.disciplines, function(
                        discipline
                      ) {
                        return _c(
                          "div",
                          { key: discipline.id },
                          [
                            _c("check-box", {
                              staticClass: "discipline-checkbox",
                              attrs: { text: discipline.name },
                              model: {
                                value: discipline.selected,
                                callback: function($$v) {
                                  _vm.$set(discipline, "selected", $$v)
                                },
                                expression: "discipline.selected"
                              }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ]
                )
              ]
            )
          }),
          _c(
            "div",
            { staticClass: "row mx-4" },
            [
              !_vm.hasValidDiscipline
                ? _c("error", {
                    staticClass: "col-12 mx-3",
                    attrs: {
                      message: _vm.validationMessages.disciplines,
                      variant: "no-border"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c("div", { staticClass: "row mx-4" }, [
            _c(
              "div",
              { staticClass: "col mb-3" },
              [
                _c("validation-provider", {
                  attrs: { name: "LocationType", rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-drop-down", {
                            attrs: {
                              "custom-error-msg":
                                _vm.validationMessages.locationType,
                              error: errors[0],
                              fieldkey: "id",
                              fieldname: "name",
                              label: "Tipo de Lugar:",
                              options: _vm.locationTypes,
                              placeholder: "Seleccione",
                              reduce: o => ({ id: o.id, name: o.name })
                            },
                            on: {
                              input: () => {
                                _vm.selectedCompanyLocation = null
                                _vm.selectedMunicipality = null
                                _vm.companyLocations = []
                              }
                            },
                            model: {
                              value: _vm.selectedLocationType,
                              callback: function($$v) {
                                _vm.selectedLocationType = $$v
                              },
                              expression: "selectedLocationType"
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col mb-3" },
              [
                _c("validation-provider", {
                  attrs: { name: "Municipality", rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-drop-down", {
                            attrs: {
                              "custom-error-msg":
                                _vm.validationMessages.municipality,
                              disabled: _vm.selectedLocationType == null,
                              error: errors[0],
                              fieldkey: "id",
                              fieldname: "name",
                              label: "Municipio:",
                              options: _vm.municipalities,
                              placeholder: "Seleccione",
                              reduce: o => ({ id: o.id, name: o.name })
                            },
                            on: {
                              input: () => {
                                _vm.selectedCompanyLocation = null
                                _vm.companyLocations = []
                              }
                            },
                            model: {
                              value: _vm.selectedMunicipality,
                              callback: function($$v) {
                                _vm.selectedMunicipality = $$v
                              },
                              expression: "selectedMunicipality"
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-sm-2 col-md-2 mb-3" },
              [
                _c("validation-provider", {
                  attrs: { name: "Location", rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-drop-down", {
                            attrs: {
                              "custom-error-msg":
                                _vm.validationMessages.location,
                              disabled: _vm.selectedMunicipality == null,
                              error: errors[0],
                              fieldkey: "id",
                              fieldname: "name",
                              label: "Lugar de Servicio:",
                              options: _vm.companyLocations,
                              placeholder: "Seleccione"
                            },
                            model: {
                              value: _vm.selectedCompanyLocation,
                              callback: function($$v) {
                                _vm.selectedCompanyLocation = $$v
                              },
                              expression: "selectedCompanyLocation"
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-sm-12 col-md-1 mb-3" },
              [
                _c("check-box", {
                  staticClass: "vertical-center",
                  attrs: { text: "Admisión" },
                  model: {
                    value: _vm.specialistLocation.canAssignSpecialistFlag,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.specialistLocation,
                        "canAssignSpecialistFlag",
                        $$v
                      )
                    },
                    expression: "specialistLocation.canAssignSpecialistFlag"
                  }
                })
              ],
              1
            ),
            _vm.selfAssign
              ? _c(
                  "div",
                  { staticClass: "col-sm-12 col-md-1 ml-3 mb-3" },
                  [
                    _c("check-box", {
                      staticClass: "vertical-center",
                      attrs: { text: "Asignar" },
                      model: {
                        value: _vm.specialistLocation.selfAssign,
                        callback: function($$v) {
                          _vm.$set(_vm.specialistLocation, "selfAssign", $$v)
                        },
                        expression: "specialistLocation.selfAssign"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "col mb-3 p-0 action-buttons" },
              [
                _c("action-button", {
                  staticClass: "py-2 m-2 btnCancel",
                  attrs: {
                    i: "fas fa-times-circle",
                    text: "Cancelar",
                    variant: "outline-danger"
                  },
                  on: { click: _vm.cancel }
                }),
                _c("action-button", {
                  staticClass: "py-2 m-2 float-right",
                  attrs: {
                    i: "fas fa-save",
                    text: "Guardar",
                    variant: "success"
                  },
                  on: { click: _vm.save }
                })
              ],
              1
            )
          ]),
          _vm.customErrorMessage != null
            ? _c("error", {
                attrs: { message: _vm.customErrorMessage, variant: "no-border" }
              })
            : _vm._e(),
          _vm.hasServiceLocationValidations
            ? _c(
                "div",
                { staticClass: "col-sm-12 col-md-12 mb-3 pt-1 pl-4 pb-3" },
                _vm._l(_vm.serviceLocationValidations, function(validation) {
                  return _c("error", {
                    key: validation.message,
                    attrs: { message: validation.message, variant: "no-border" }
                  })
                }),
                1
              )
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }